import axios from 'axios'
import QS from 'qs'
// import {config} from './config.js';
import Vue from "vue";

let OA_API = Vue.prototype.CoreNew.OA_API_IP;

const service = axios.create({
    // baseURL: config.OA_API,
    baseURL: OA_API,
    timeout: 60000,
    responseType: "json"
});

//请求拦截
service.interceptors.request.use(
    config => {
        const Authorization = JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'));
        if (Authorization) {
            //设置统一的请求header
            config.headers.Authorization = Authorization;
        }
        // form data
         if (config.method === 'post' && config.data) {
             config.headers = {
                 'Content-Type': 'application/x-www-form-urlencoded',
                 "Authorization": Authorization
             }
             // QS.stringify(config.data);
         }

        // this.$router.push("/login/");
        return config
    },
    error => {
        if (error.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
            console.log("错误回调", error);
            this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--行业新闻--失败"+error);//记录错误
            return Promise.reject(error);          // reject这个错误信息
        }
        return Promise.reject(error)
    }
)
//响应拦截
service.interceptors.response.use(
    res => {
        if (res) {
            return res.data;
        } else {
            return ''
        }
    },
    error => {

    })
export default service
